export class CaseInformation{
  incidentDate:Date = null;
  injuryDescription:string = '';
  incidentDescription:string = '';
}
